import { useAppSelector } from "@app/hooks";
import { useGetMediaByIdsQuery } from "@services/media";
import { selectProperties } from "@survey/surveySelectors";

/**
 * Single hook for ensuring media data is fetched for all non-hidden properties
 * Should be called once at the top level of preview components
 * Fetches media for ALL properties that aren't hidden, regardless of current location flags
 */
export const useEnsureMediaData = () => {
  const allProperties = useAppSelector(selectProperties);

  // Filter out only hidden properties, ignore current location flags
  // We want media for all non-hidden properties regardless of visibility settings
  const ids = allProperties?.map((property) => property.propertyId);

  // Fetch media data for all non-hidden properties (single API call)
  const result = useGetMediaByIdsQuery(
    { ids, ownerType: "PROPERTY" },
    {
      skip: !ids?.length,
    },
  );

  return result;
};
